<template>
  <div class="c-navigation-bar md:hidden w-full sticky bottom-0 z-30">
    <scrollactive
      :modify-url="true"
      :offset="offset"
      :exact="true"
      active-class="is-active"
      tag="ul"
      class="flex bg-secondary-dark text-sm text-white"
    >
      <li class="px-4">
        <a
          href="#ingredients"
          class="block pt-4 pb-5 border-t-4 border-secondary-dark scrollactive-item"
        >
          {{ ingredientsTitle }}
        </a>
      </li>
      <li class="px-6">
        <a
          href="#instructions"
          class="block pt-4 pb-5 border-t-4 border-secondary-dark scrollactive-item"
        >
          {{ instructionsTitle }}
        </a>
      </li>
    </scrollactive>
  </div>
</template>

<script>
export default {
  props: {
    ingredientsTitle: {
      type: String,
      required: true
    },
    instructionsTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      offset: 0
    }
  }
}
</script>
<style>
  .c-navigation-bar .is-active {
    @apply font-bold border-white;
  }
</style>
